module.exports = __webpack_public_path__ + "img/googlemeet_512x512.88ba9830.png";